import { createSlice } from "@reduxjs/toolkit";

const initialAdminDashboardState = {
  listLoading: false,
  actionsLoading: false,
  statisticsCardLoading: false,
  statisticsPanel: undefined,
  inventoryStatusLoading: false,
  inventoryStatus: undefined,
  entities: [],
  totalPage: 0,
  lastError: null,
  message: null,
  error: null,
};
export const callTypes = {
  statisticsCards: "statisticsCards",
  inventoryStatus: "inventoryStatus",

  list: "list",
  action: "action",
};

export const adminDashboardSlice = createSlice({
  name: "adminDashboards",
  initialState: initialAdminDashboardState,
  reducers: {
    catchError: (state, action) => {
      state.error = action.payload.error.clientMessage;
      switch (action.payload.callType) {
        case callTypes.list:
          state.listLoading = false;
          break;
        case callTypes.action:
          state.actionsLoading = false;
          break;
        case callTypes.statisticsCards:
          state.statisticsCardLoading = false;
          break;
        case callTypes.inventoryStatus:
          state.inventoryStatusLoading = false;
          break;
        default:
          state.listLoading = false;
          state.actionsLoading = false;
          state.statisticsCardLoading = false;
          state.inventoryStatusLoading = false;
          break;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      state.message = null;

      switch (action.payload.callType) {
        case callTypes.list:
          state.listLoading = true;
          break;
        case callTypes.action:
          state.actionsLoading = true;
          break;
        case callTypes.statisticsCards:
          state.statisticsCardLoading = true;
          break;
        case callTypes.heatmap:
          state.heatmapLoading = true;
          break;
        case callTypes.recentLogins:
          state.recentLoginLoading = true;
          break;
        case callTypes.tenantSubscription:
          state.tenantSubscriptionLoading = true;
          break;
        case callTypes.inventoryStatus:
          state.inventoryStatusLoading = true;
          break;
        default:
          state.listLoading = true;
          state.actionsLoading = true;
          state.statisticsCardLoading = true;
          state.inventoryStatusLoading = true;
          break;
      }
    },
    endCall: (state, action) => {
      state.error = null;
      state.message = null;
      switch (action.payload.callType) {
        case callTypes.list:
          state.listLoading = false;
          break;
        case callTypes.action:
          state.actionsLoading = false;
          break;
        case callTypes.statisticsCards:
          state.statisticsCardLoading = false;
          break;
        case callTypes.inventoryStatus:
          state.inventoryStatusLoading = false;
          break;
        default:
          state.listLoading = false;
          state.actionsLoading = false;
          state.statisticsCardLoading = false;
          state.inventoryStatusLoading = false;
          break;
      }
    },
    activeStoresFetched: (state, action) => {
      state.entities = action.payload.entities;
      state.listLoading = false;
      state.totalPage = action.payload.totalPage;
      state.error = null;
    },
    statisticsPanelFetched: (state, action) => {
      state.statisticsCardLoading = false;
      state.statisticsPanel = action.payload.statisticsPanel;
      state.error = null;
    },
    inventoryStatusFetched: (state, action) => {
      state.inventoryStatusLoading = false;
      state.inventoryStatus = action.payload.inventoryStatus;
      state.error = null;
    },
    setMessage: (state, action) => {
      state.error = null;
      state.message = action.payload.msgResponse;
    },
  },
});
